import React, { memo, useCallback } from 'react'
import { makeStyles } from '@mui/styles'
import { Box, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CloseIcon from '@mui/icons-material/Close';
import CustomButton from 'components/CustomButton';

const useStyles = makeStyles((theme) => ({
  container: {
    width: '100%',
    padding: theme.spacing(6, 8),
    boxShadow: `0px 0px 8px 0px #1961BF4D`,
    background: `linear-gradient(90deg, rgba(255, 213, 213, 0.7) 9.71%, #FFFFFF 20%)`,
    borderRadius: theme.spacing(1),
    display: 'flex',
    gap: theme.spacing(10)
  },
  containerPending: {
    width: '100%',
    padding: theme.spacing(6, 8),
    boxShadow: `0px 0px 8px 0px #1961BF4D`,
    background: `linear-gradient(90deg, #FFF6E5 9.71%, #FFFFFF 20%)`,
    borderRadius: theme.spacing(1),
    display: 'flex',
    gap: theme.spacing(10)
  },
  dangerChip: {
    display: 'flex',
    gap: theme.spacing(1),
    backgroundColor: theme.palette.danger['clr-100'],
    borderRadius: theme.spacing(1),
    padding: theme.spacing(1, 2)
  },
  pendingChip: {
    display: 'flex',
    gap: theme.spacing(1),
    backgroundColor: theme.palette.warning['clr-100'],
    borderRadius: theme.spacing(1),
    padding: theme.spacing(1, 2)
  }
}))

export const FeedbackSkippedCard = memo(({ setSkippedAttempt }) => {
  const classes = useStyles();

  const handleClose = useCallback(() => {
    setSkippedAttempt(false);
  }, [setSkippedAttempt]);

  return (
    <Box className={classes.container}>
      <img
        src='https://assets.languify.in/images/creditExhaust.png'
        alt='credit'
        width={100}
      />
      <Box display='flex' flexDirection='column' gap='12px' width='100%'>
        <Box display='flex' justifyContent='space-between'>
          <Box className={classes.dangerChip}>
            <InfoOutlinedIcon
              sx={{
                fontSize: 16,
                color: '#C51407',
                transform: 'rotate(180deg)'
              }}
            />
            <Typography variant='body02-bold' color='danger.clr-700'>Credit update</Typography>
          </Box>
          <CloseIcon
            sx={{ color: '#636F7F', cursor: 'pointer' }}
            onClick={handleClose}
          />
        </Box>
        <Typography variant='h6-medium' color='neutral.clr-800'>
          As the last case study attempt was ended without completing the analysis and hints were used, we couldn't generate a feedback report. One credit was still consumed.
        </Typography>
      </Box>
    </Box>
  )
})

const FeedbackPendingCard = memo(({ setPendingAttempt }) => {
  const classes = useStyles();

  const handleShowAttempt = useCallback(() => {
    const element = document.getElementById('recent-attempts');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    // Close the card immediately rather than waiting
    setPendingAttempt(false);
  }, [setPendingAttempt]);

  return (
    <Box className={classes.containerPending}>
      <img
        src='https://assets.languify.in/images/feedbackPendingTwo.png'
        alt='feedback pending'
        width={100}
      />
      <Box display='flex' flexDirection='column' gap='12px' width='100%'>
        <Box display='flex'>
          <Box className={classes.pendingChip}>
            <InfoOutlinedIcon
              sx={{
                fontSize: 16,
                color: '#664100',
                transform: 'rotate(180deg)'
              }}
            />
            <Typography variant='body02-bold' color='warning.clr-700'>Feedback pending</Typography>
          </Box>
        </Box>
        <Box display='flex' gap='32px'>
          <Typography variant='h6-medium' color='neutral.clr-800'>
            Looks like your case study attempt closed midway, and the feedback report wasn't generated! But since we have received your response, you can still generate your feedback report 👍🏻
          </Typography>
          <CustomButton
            sx={{ minWidth: '141px' }}
            onClick={handleShowAttempt}
          >
            Show attempt
          </CustomButton>
        </Box>
      </Box>
    </Box>
  )
})

export default FeedbackPendingCard
